import type { ReactElement } from "react";
import { CmtsDashboardsContainer } from "../../core/containers/domain/dashboardsRouteContainers.js";
import type { CmtsHostRuntime } from "../../../app/appRuntime.js";

export function Component(props: { readonly runtime: CmtsHostRuntime }): ReactElement {
  return <CmtsDashboardsContainer runtime={props.runtime} />;
}

export default Component;
